var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import _Handlebars2 from "../../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import { View } from "../../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import Enums from "../../../../util/Enums.js";
import Util from "../../../../util/Util.js";
import { WIDGET_FOOTER_CLASS } from "../../utils/Constants.js";
const OktaSignInWidgetOnCaptchaLoadedCallback = "OktaSignInWidgetOnCaptchaLoaded";
const OktaSignInWidgetOnCaptchaSolvedCallback = "OktaSignInWidgetOnCaptchaSolved";
const HCAPTCHA_URL = "https://hcaptcha.com/1/api.js";
const RECAPTCHAV2_URL = "https://www.google.com/recaptcha/api.js";
var CaptchaView = View.extend({
  className: "captcha-view",
  template: _Handlebars2.template({
    "1": function(container, depth0, helpers, partials, data) {
      var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return '<div id ="captcha-container" class="' + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 76
          }
        }
      }) : helper)) + '" data-sitekey="' + alias4((helper = (helper = lookupProperty(helpers, "siteKey") || (depth0 != null ? lookupProperty(depth0, "siteKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "siteKey",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 103
          }
        }
      }) : helper)) + '" data-callback="' + alias4((helper = (helper = lookupProperty(helpers, "onCaptchaSolvedCallback") || (depth0 != null ? lookupProperty(depth0, "onCaptchaSolvedCallback") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "onCaptchaSolvedCallback",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 120
          },
          "end": {
            "line": 1,
            "column": 147
          }
        }
      }) : helper)) + '" data-size="invisible"></div>';
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function(container, depth0, helpers, partials, data) {
      var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return void 0;
      };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isCaptchaConfigured") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 184
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData: function() {
    if (this.captchaConfig) {
      const className = this.captchaConfig.type === "HCAPTCHA" ? "h-captcha" : "g-recaptcha";
      return {
        siteKey: this.captchaConfig.siteKey,
        isCaptchaConfigured: true,
        onCaptchaSolvedCallback: OktaSignInWidgetOnCaptchaSolvedCallback,
        className
      };
    } else {
      return {};
    }
  },
  initialize: function() {
    if (this.options.appState.get("captcha")) {
      this.captchaConfig = this.options.appState.get("captcha");
      this._addCaptcha();
    }
  },
  remove: function() {
    View.prototype.remove.apply(this, arguments);
    if (this.captchaConfig.type === "HCAPTCHA") {
      window.hcaptcha = void 0;
    } else if (this.captchaConfig.type === "RECAPTCHA_V2") {
      window.grecaptcha = void 0;
    }
  },
  /**
   *  Load the CAPTCHA lib dynamically (either HCAPTCHA or RECAPTCHAV2). Once loaded, trigger an event to inform
   *  the parent form to actually render the CAPTCHA.
  * */
  _addCaptcha: function() {
    const onCaptchaSolved = (token) => {
      const captchaObject = this._getCaptchaOject();
      const captchaId = this.$el.find("#captcha-container").attr("data-captcha-id");
      captchaObject.reset(captchaId);
      const fieldName = this.options.name;
      this.model.set(fieldName, token);
      this.options.appState.trigger("saveForm", this.model);
    };
    const onCaptchaLoaded = () => {
      if (this.$el.find("#captcha-container").attr("data-captcha-id")) {
        return;
      }
      const captchaObject = this._getCaptchaOject();
      this.model.set(this.options.name, "tempToken");
      const captchaId = captchaObject.render("captcha-container", {
        sitekey: this.captchaConfig.siteKey,
        callback: onCaptchaSolved
      });
      this.$el.find("#captcha-container").attr("data-captcha-id", captchaId);
      this.options.appState.trigger("onCaptchaLoaded", captchaObject);
      if (this.captchaConfig.type === "HCAPTCHA") {
        this._addHCaptchaFooter();
      }
    };
    window[OktaSignInWidgetOnCaptchaLoadedCallback] = onCaptchaLoaded;
    window[OktaSignInWidgetOnCaptchaSolvedCallback] = onCaptchaSolved;
    if (this.captchaConfig.type === "HCAPTCHA") {
      this._loadCaptchaLib(this._getCaptchaUrl(HCAPTCHA_URL, "hcaptcha"));
    } else if (this.captchaConfig.type === "RECAPTCHA_V2") {
      this._loadCaptchaLib(this._getCaptchaUrl(RECAPTCHAV2_URL, "recaptcha"));
    }
  },
  /**
   *  We dynamically inject <script> tag into our login container because in case the customer is hosting
   *  the SIW, we need to ensure we don't go out of scope when injecting the script.
  * */
  _loadCaptchaLib: function(url) {
    let scriptTag = document.createElement("script");
    scriptTag.src = url;
    scriptTag.async = true;
    scriptTag.defer = true;
    document.getElementById(Enums.WIDGET_CONTAINER_ID).appendChild(scriptTag);
  },
  _addHCaptchaFooter: function() {
    const footerContainer = document.getElementsByClassName(WIDGET_FOOTER_CLASS);
    if (footerContainer.length) {
      const template = _Handlebars2.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function(container, depth0, helpers, partials, data) {
          var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return void 0;
          };
          return '<div class="captcha-footer"><span class="footer-text">' + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "$2": "<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",
              "$1": "<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",
              "bundle": "login",
              "code": "hcaptcha.footer.label"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 54
              },
              "end": {
                "line": 1,
                "column": 238
              }
            }
          })) + "</span></div>";
        },
        "useData": true
      });
      footerContainer[0].insertAdjacentHTML("beforeend", template());
    }
  },
  _getCaptchaOject: function() {
    const captchaObject = this.captchaConfig.type === "HCAPTCHA" ? window.hcaptcha : window.grecaptcha;
    return captchaObject;
  },
  /**
   *  Supported params for hCaptcha script:
   *   https://github.com/hCaptcha/hcaptcha-loader#props
   *   (starting from 'apihost')
   *  Supported params for reCAPTCHA script:
   *   https://developers.google.com/recaptcha/docs/display#javascript_resource_apijs_parameters
  * */
  _getCaptchaUrl: function(defaultBaseUrl, settingsKey) {
    const locale = this.options.settings.get("language");
    const scriptSource = this.options.settings.get(`${settingsKey}.scriptSource`);
    const scriptParams = this.options.settings.get(`${settingsKey}.scriptParams`);
    const baseUrl = scriptSource || defaultBaseUrl;
    const params = __spreadProps(__spreadValues({}, scriptParams), {
      onload: OktaSignInWidgetOnCaptchaLoadedCallback,
      render: "explicit",
      hl: locale || navigator.language
    });
    const query = Util.searchParamsToString(params);
    return baseUrl + "?" + query;
  }
});
export { CaptchaView as default };
